// 第1张
const imgAllA = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578027756/sl_r3p.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015884744/r3_plus_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015958676/r3_plus_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751095861012/sl_r3s.png',
        h5: '',
    },
};
export const imgLocaleA: any = {
    us: imgAllA.NA,
    ca: imgAllA.NA,
    br: imgAllA.NA,
    mx: imgAllA.NA,
    uk: imgAllA.UK,
    eu: imgAllA.EU,
    de: imgAllA.EU,
    fr: imgAllA.EU,
    it: imgAllA.EU,
    es: imgAllA.EU,
    ph: imgAllA.PH,
};

// 第2张
const imgAllB = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578027910/sl_r3m.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015903418/r3_max_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725015976839/r3_max_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751095860661/sl_r3s%20(1).png',
        h5: '',
    },
};
export const imgLocaleB: any = {
    us: imgAllB.NA,
    ca: imgAllB.NA,
    br: imgAllB.NA,
    mx: imgAllB.NA,
    uk: imgAllB.UK,
    eu: imgAllB.EU,
    de: imgAllB.EU,
    fr: imgAllB.EU,
    it: imgAllB.EU,
    es: imgAllB.EU,
    ph: imgAllB.PH,
};

// 第3张
const imgAllC = {
    NA: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1724578028088/sl_r3mp.png',
        h5: '',
    },
    EU: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725017821546/r3_plus_max_eu.png',
        h5: '',
    },
    UK: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1725017873748/r3_plus_max_uk.png',
        h5: '',
    },
    PH: {
        pc: 'https://websiteoss.ecoflow.com/upload/image/1751095860831/sl_r3s%20(2).png',
        h5: '',
    },
};
export const imgLocaleC: any = {
    us: imgAllC.NA,
    ca: imgAllC.NA,
    br: imgAllC.NA,
    mx: imgAllC.NA,
    uk: imgAllC.UK,
    eu: imgAllC.EU,
    de: imgAllC.EU,
    fr: imgAllC.EU,
    it: imgAllC.EU,
    es: imgAllC.EU,
    ph: imgAllC.PH,
};

// 第4张
const imgAllD = {
    NA: {
        pc: '',
        h5: '',
    },
    EU: {
        pc: '',
        h5: '',
    },
    UK: {
        pc: '',
        h5: '',
    },
};
export const imgLocaleD: any = {
    us: imgAllD.NA,
    ca: imgAllD.NA,
    br: imgAllD.NA,
    mx: imgAllD.NA,
    uk: imgAllD.UK,
    eu: imgAllD.EU,
    de: imgAllD.EU,
    fr: imgAllD.EU,
    it: imgAllD.EU,
    es: imgAllD.EU,
};
